import useGameContext from '~/client/components/Game/context/Game/useGameContext';

const useGameTitle = () => {
  const { game } = useGameContext();
  const name = game?.name;
  const providerName = game?.menuItem?.[0]?.name ?? '';
  const providerHandle = game?.menuItem?.[0]?.handle ?? '';
  const href = `/providers/${providerHandle}`;
  return { name, providerName, href };
};

export default useGameTitle;
